// student-versions (Trello ch3IfCAK) — the pure, IMPORT-FREE `# CHANGES` line writer.
//
// When a student saves a version, the note ("What changed?") is written into a `# CHANGES`
// comment block at the top of `main.py`, so the file carries its own release notes:
//
//     # CHANGES
//     # v1 — Added a coin
//     # v2 — The coin now spins
//
// Rules (decisions.md Round 3 / spec "CHANGES lines are inserted by a pure helper"):
//   * the header is the FIRST line matching /^#\s*CHANGES\b/i, anywhere in the file;
//   * the block ends at the first line below it that does not start with `#` (a blank line ends
//     it), and the new line goes right after the block's last comment line — hand-typed lines
//     are kept and nothing existing is rewritten;
//   * a block that is not at the top is appended to where it is (no second block is created);
//   * only when no header exists anywhere is a new block put at line 0, followed by a blank line;
//   * the name and the note are whitespace-collapsed (newlines included); the note is cut to 120
//     characters with an ellipsis;
//   * the file's own line ending (CRLF or LF) is kept.
//
// Host-only spec: test/editor/versions-changes-line.test.js.

export var NOTE_MAX = 120;
export var HEADER_RE = /^#\s*CHANGES\b/i;

export function collapse(text) {
  return String(text == null ? '' : text).replace(/\s+/g, ' ').trim();
}

export function clipNote(note) {
  var text = collapse(note);
  if (text.length <= NOTE_MAX) { return text; }
  return text.slice(0, NOTE_MAX - 1).replace(/\s+$/, '') + '…';
}

export function changesLine(label, note) {
  return '# ' + collapse(label) + ' — ' + clipNote(note);
}

export function insertChangesLine(mainPy, label, note) {
  var source = (typeof mainPy === 'string') ? mainPy : '';
  var eol = source.indexOf('\r\n') !== -1 ? '\r\n' : '\n';
  var line = changesLine(label, note);
  var lines = source.split(/\r?\n/);

  var header = -1;
  for (var i = 0; i < lines.length; i++) {
    if (HEADER_RE.test(lines[i])) { header = i; break; }
  }

  if (header === -1) {
    var block = '# CHANGES' + eol + line + eol + eol;
    return block + source;
  }

  var last = header;
  for (var j = header + 1; j < lines.length; j++) {
    if (lines[j].charAt(0) !== '#') { break; }
    last = j;
  }
  lines.splice(last + 1, 0, line);
  return lines.join(eol);
}
